import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    countries: [],
    loading: false,
    saving: false
};

export default function user(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_COUNTRY:
            newState.loading = true;
            break;

        case actions.SAVING_COUNTRY:
            newState.saving = true;
            break;

        case actions.RECEIVED_COUNTRIES:
            newState.countries = utils.mapById(action.payload);
            newState.loading = false;
            break;

        case actions.SAVED_COUNTRY:
            let found = false;

            for (let i = 0; i < newState.countries.length; i++) {
                if(newState.countries[i].id === action.payload.id){
                    found = true;

                    newState.countries[i] = action.payload;
                }
            }

            if(!found) {
                newState.countries.add(
                    action.payload
                );
            }
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_COUNTRIES:
            newState.loading = false;
            newState.saving = false;
            break;

        default: break;
    }

    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/country.js